$(document).ready(function () {
  $('.blog-card').fadeIn();

  $('.season-tab').on('click', function () {
    const filter = $(this).data('filter');

    $('.season-tab').removeClass('active');
    $(this).addClass('active');

    $('.blog-card').each(function() {
      const cardFilter = $(this).data('filter');
      if (filter === 'all' || cardFilter.includes(filter)) {
        $(this).fadeIn();
      } else {
        $(this).fadeOut();
      }
    });
  });

 $(".benefit-name").on("click", function () {
  $(this)
    .closest(".benefit")
    .toggleClass("active") // Add or remove class to parent
    .find(".benefit-description")
    .toggleClass("visible");
});

});


function applyFilter() {
  if ($(window).width() <= 768) { // Apply only for screens ≤ 768px (mobile)
    
    let defaultFilter = $(".filter-button").first().data("filter"); // Get first filter (default active)
    
    $(".filter-button").removeClass("active"); // Remove active class from all buttons
    $(".filter-button").first().addClass("active"); // Add active class to first button
    
    $(".benefit-dropdown-items").hide(); // Hide all benefits first
    $(".benefit-dropdown-items." + defaultFilter).show(); // Show only the default filter benefits

    $(".filter-button").on("click", function () {
      let filterClass = $(this).data("filter"); // Get the clicked filter
      
      $(".filter-button").removeClass("active"); // Remove active class from all buttons
      $(this).addClass("active"); // Add active class to clicked button

      if (filterClass === "all") {
        $(".benefit-dropdown-items").show(); // Show all if "all" is selected
      } else {
        $(".benefit-dropdown-items").hide(); // Hide all first
        $(".benefit-dropdown-items." + filterClass).show(); // Show elements that have the selected class
      }
    });

  } else {
    $(".benefit-dropdown-items").show(); // Show all benefits on larger screens
  }
}

// Run on page load
$(document).ready(applyFilter);

// Run on window resize (to handle changes in screen size)
$(window).resize(applyFilter);


